import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { IActionSheetAction, hideAction, uploadWithoutWechatAction, uploadFileAction, IActionSheetStoreState } from '@/redux/ui/actionsheet';
import { getIsWxClient } from '@/server/utils';
import config from '@/server/config';
// import store from '@/redux';

interface IProps {
    project?: string;
    visible: boolean;
    type?: string;
    size?: number;
    hideAction(): void;
    uploadFileAction(project?: string, size?: number, data?: object): void;
    uploadWithoutWechatAction(project?: string, size?: number, data?: object): void;
}

class ActionSheet extends React.Component<IProps, any> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isWechat: getIsWxClient()
        };
    }
    public componentDidMount() { 
        const xhrData = 'jsApiDomain=&url=' + encodeURIComponent(window.location.href.split('#')[0]);
        (window as any).WeChatShare({
            jsApiList: ["chooseImage", "previewImage", "uploadImage", "downloadImage"],
            data: xhrData,
            url: config.WAPAPI
        });
    }
    public render() {
        return (
            <section className={`actionsheet ${this.props.visible ? 'active' : ''}`}>
                <div className="actionsheet-animation">
                    {
                        this.props.type === 'file' ?
                            <div className="actionsheet-container">
                                <div className="actionsheet-input-file">
                                    <input type="file" onChange={() => this.props.uploadFileAction(this.props.project, 0)}/>
                                    <p className="actionsheet-file">选择文件</p>
                                </div>
                        </div>
                            :
                        <div className="actionsheet-container">
                                <p className="actionsheet-title">请选择图片</p>
                                {
                                    // this.state.isWechat ?
                                    // <div>
                                    //     <p className="actionsheet-camera" onClick={() => this.photoAction()}>拍照</p>
                                    //     <p className="actionsheet-album" onClick={() => this.albumAction()}>从相册选择</p>
                                    // </div>
                                    // : 
                                    // <div className="actionsheet-input-file">
                                    //         <input type="file" onChange={() => this.props.uploadWithoutWechatAction(this.props.project)}/>
                                    //     <p className="actionsheet-album">从相册选择</p>
                                    // </div>
                                }
                                <div className="actionsheet-input-file">
                                        <input type="file" accept="image/*" capture="camera" onChange={() => this.props.uploadWithoutWechatAction(this.props.project, this.props.size)}/>
                                    <p className="actionsheet-album">拍摄</p>
                                </div>
                                <div className="actionsheet-input-file">
                                        <input type="file" onChange={() => this.props.uploadWithoutWechatAction(this.props.project, this.props.size)}/>
                                    <p className="actionsheet-album">从相册选择</p>
                                </div>
                        </div>
                    }
                    
                    <div className="actionsheet-cancel" onClick={() => this.props.hideAction()}>取消</div>
                </div>
            </section>
        )
    }

    // 拍照
    // private photoAction() { 
    //     this.selectByWechat('camera');
    // }

    // 从相册选择
    // private albumAction() { 
    //     this.selectByWechat('album');
    // }

    /**
     * 通过微信选择图片
     * @param type {string} 选择方式
     */
    // private selectByWechat(type: string) { 
    //     (window as any).wx.chooseImage({
    //         count: 1, // 默认9，这里每次只处理一张照片
    //         sizeType: ['original', 'compressed'],   // 可以指定是原图还是压缩图，默认二者都有
    //         sourceType: [type],        // 可以指定来源是相册还是相机，默认二者都有
    //         success(r: any) {
    //             setTimeout(() => { 
    //                 (window as any).wx.uploadImage({
    //                     localId: r.localIds.toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
    //                     isShowProgressTips: 1, // 默认为1，显示进度提示
    //                     success(sr: any) {
    //                         const serverId = sr.serverId; // 返回图片的服务器端ID
    //                         alert(serverId);
    //                         store.dispatch({
    //                             type: types.ACTIONSHEET_UPLOAD_WECHAT,
    //                             data: {
    //                                 content: serverId
    //                             }
    //                         });
    //                     },
    //                     fail(err: any) {
    //                       return false;
    //                     }
    //                 });
    //             }, 100);
    //         } 
    //     });
    // }
}

const mapStateToProps = (state: any): IActionSheetStoreState => {
    return {
        ...state.actionSheetReducers
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IActionSheetAction>) => {
    return bindActionCreators({ hideAction, uploadWithoutWechatAction, uploadFileAction }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionSheet);